import ezoLogo from '@/assets/crm-logo.png';
import nickelnovaFavicon from '@/assets/nickelnova-favicon.png';
import nickelnovaLogo from '@/assets/nickelnova-logo.png';

// nickelnova.com is a second CloudFront alias over the same prod bundle, so the brand is picked at runtime.
// Locally: http://nickelnova.localhost:3000
const isNickelNova = /(^|\.)nickelnova\./.test(window.location.hostname);

const brand = isNickelNova
  ? {
      title: 'NickelNova',
      logo: nickelnovaLogo,
      favicon: nickelnovaFavicon,
      product: 'NickelNova',
      company: 'NICKELNOVA TECHNOLOGY LLC',
      legalEntity: 'NICKELNOVA TECHNOLOGY LLC',
      site: 'https://nickelnova.com',
      email: 'mail@nickelnova.com',
    }
  : {
      title: 'EzoCRM',
      logo: ezoLogo,
      favicon: `${process.env.PUBLIC_URL}/favicon.ico`,
      product: 'Ezocrm',
      company: '"EZOTEAM REKLAM DANIŞMANLIK TİCARET" LIMITED ŞIRKETI',
      legalEntity: '"ETK ÖZEL EĞİTİM HİZMETLERİ" LIMITED ŞIRKETI',
      site: 'https://ezo-crm.com',
      email: 'mail@ezo-crm.com',
    };

export default {
  brand,
  apiUrl: process.env.REACT_APP_API_URL || 'https://server.ezo-crm.com/app',
  isProd: ['MAIN', 'RELEASE'].includes(process.env.REACT_APP_APP_TYPE ?? ''),
  deviceRedirectUrl: 'https://ezo-crm.com/',
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || '',
  instagramAppId: process.env.REACT_APP_INSTAGRAM_APP_ID || '',
  instagramRedirectUri:
    process.env.REACT_APP_INSTAGRAM_REDIRECT_URI ||
    `${window.location.origin}/oauth/instagram/callback`,
  isInstagramConnect: process.env.REACT_APP_IS_INSTAGRAM_CONNECT === 'true',
  /** DEV-2839 Telegram QR auth button; needs server qr-auth + telegram QR on the same env. */
  isTgQrAuthEnabled: process.env.REACT_APP_TG_QR_AUTH === 'true',
};
